<template>
    <div>
        <span class="span-title">{{ $t('orders.pricing_model') }}</span>
        <select
            id="pricingModel"
            v-model="selectedPricingModel"
            class="form-select form-select-sm mb-3"
        >
            <option :value="null">
                {{ $t('orders.no_pricing') }}
            </option>
            <option
                v-for="option in pricingModels"
                :key="option.id"
                :value="option.id"
            >
                {{ currency }} / {{ unitToText(option.unit1) }}
                {{ option.unit2 ? "/" + unitToText(option.unit2) : "" }}
            </option>
        </select>
    </div>
</template>

<script>
import {priceHelper} from "../mixins/PricingMixin";
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: "PricingModelFilter",
    mixins: [priceHelper, restApi],
    props: {
        modelValue: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            pricingModels: [],
            selectedPricingModel: null
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    watch: {
        selectedPricingModel: function (){
            let model = this.pricingModels.find(item => item.id === this.selectedPricingModel)
            this.$emit('update:modelValue', model)
        }
    },
    mounted: function () {
        this.fetchPricingModels()
    },
    methods: {
        fetchPricingModels: function () {
            this.loading = true
            this.pricingModels = []
            this.restFetch(this.pricingModeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.pricingModels = response.data
            if(this.modelValue) {
                let model = this.pricingModels.find(item => item.id === this.modelValue.id)
                if(model) {
                    this.selectedPricingModel = model.id
                } else {
                    this.selectedPricingModel = null
                    this.$emit('input', null)
                }
            }
            this.loading = false
        },
    }
}
</script>

<style scoped>

</style>
